import type { NestedFilterKeys } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/react-table';
import PersonCell from '@/components/DataTable/Cells/PersonCell';
import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import type { HelperOptions } from '@/components/DataTable/types';
import type { Person } from '@/features/app-user/types';

/** AppUserを軸に紐付くPersonを表現するカラムコンポーネント */
export function PersonColumn<TData>(id: NestedFilterKeys<TData, Person>, helperOptions: HelperOptions): ColumnDef<TData> {
  const {
    minWidth
  } = helperOptions;
  return {
    accessorKey: id,
    meta: {
      i18nKey: 'person',
      thStyle: {
        minWidth
      }
    },
    header(props) {
      return <DataTableColumnHeader {...props} />;
    },
    cell({
      row
    }) {
      const person = row.getValue<Person | null>(id);
      return <PersonCell person={person} />;
    },
    enableSorting: true
  };
}